import { useEffect, useState } from 'react';
import { AppFeature, Features, getFeatures, onFeaturesChange, peekFeatures } from '../api/featuresApi';

/** The instance feature toggles (`global/features`), or null while loading. */
export function useFeatures(): Features | null {
    const [features, setFeatures] = useState<Features | null>(peekFeatures);

    useEffect(() => {
        let cancelled = false;
        getFeatures().then(value => {
            if (!cancelled) setFeatures(value);
        });
        const unsubscribe = onFeaturesChange(setFeatures);
        return () => {
            cancelled = true;
            unsubscribe();
        };
    }, []);

    return features;
}

/** Whether one feature is on; true while loading (absent = on), so nothing flickers away. */
export function useFeature(feature: AppFeature): boolean {
    return useFeatures()?.[feature] ?? true;
}
